import React, { useState } from 'react';
import Spinner from '../Spinner';
import { toast } from 'react-toastify';
import axios from 'axios';


const EmailForm = ({handleEmailSubmitSuccess}) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    if(verifyEmail(email)) {
      toast('Please use a valid email', {
        autoClose: 6000,
        type: toast.TYPE.WARNING,
      });
      return;
    }
    setIsLoading(true);
    axios.post(`/subscription/v1/email-verification`, {'customerEmail': email})
    .then((res) => {
      handleEmailSubmitSuccess(email);
    }).catch((err) => {
      console.log(err)
      toast(err.response.data.error, {
        autoClose: 6000,
        type: toast.TYPE.ERROR,
      });
    })
    .finally(() => {
      setIsLoading(false);
    })
    
  };

  const verifyEmail = (email) => {
    if(!/\S+@\S+\.\S+/.test(email)) {
      setIsEmailValid(true);
      return true;
    }
    setIsEmailValid(false);
    return false;
  }

  const handleEmailChange = (event) => {
    event.preventDefault();
    setEmail(event.target.value)
    verifyEmail(event.target.value);
  }

  return (
    <>
      <div className="grid grid-cols-1 gap-4 justify-items-center mb-3">
        <span className="text-white font-bold text-xl sm:text-lg">Sign up to get started for free!</span>
      </div>

      <div className="grid grid-cols-1 gap-1 mb-5 px-2">
        <span className=" text-white font-light text-sm">Email Address</span>
        <input
          value={email}
          onChange={handleEmailChange}
          type="text"
          name="customerEmail"
          className={`bg-D9D9D9 block w-full rounded-[12px] border-gray-300 shadow-sm focus:ring-ETWOrange sm:text-sm ${
                      isEmailValid === true ? 'border-red-500 focus:ring-red-500' : 'focus:border-ETWOrange focus:ring-ETWOrange'
                    }`}
          ></input>
      </div>
      <div className="grid grid-cols-1 gap-1 mb-5 px-2 justify-items-center ">
        <button onClick={handleSubmit} className="bg-8A8988 text-white font-bold text-base rounded-[12px] h-10 w-fit hover:bg-ETWOrange disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-500 disabled:shadow-none dark:disabled:border-gray-700 dark:disabled:bg-gray-800/20 px-1" disabled={isLoading}>
          {isLoading ? <Spinner /> : 'Send email verification code'}
        </button>
      </div>

      <div className="grid grid-cols-1 gap-1 ">
        <span className="text-white font-light text-xs text-center">
          First user is free, no credit card required. By clicking &quot;Send email verification code&quot;, 
          you agree to email communications from ETW
        </span>

        <span className="text-white font-bold text-sm text-center">
          Did&lsquo;t get the email? Check your spam! of it&lsquo;s not there reach out to support@etw.com
        </span>
      </div>

    </>
  );
};

export default EmailForm;